import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { DataService } from './data.svc';
import { AuthService } from './auth.svc';

@Injectable({
	providedIn: 'root'
  }) 

  export class FcmService {
	constructor(private fireMessaging: AngularFireMessaging, private dataService: DataService, private authService: AuthService) {
		
	//const broadcast = new BroadcastChannel('myAppChannel');
	// broadcast.onmessage = (event) => {
	// 	console.log(event);
	//   }

	//   navigator.serviceWorker.register('firebase-messaging-sw.js').then(function() {
    //     return navigator.serviceWorker.ready;
    // }).then(function(reg) {
    //     console.log('Service Worker is ready', reg);
    //     reg.pushManager.subscribe({userVisibleOnly: true}).then(function(sub) {

    //         console.log('endpoint:', sub.endpoint);
    //         reg.active.postMessage(localStorage.getItem('currentUser'));
    //         console.log("Posted message");

    //     });
    // }).catch(function(error) {
    //     console.log('Error : ', error);
    // });

	}
	
	requestToken(currentUser): void {
		this.fireMessaging.requestToken.subscribe({
			next: token => {
			  // Upload the user FCM token to your server.
			  //console.log(token);
			  localStorage.setItem("fcmToken",token.toString());

			  this.dataService.saveToken(token, currentUser).subscribe(res => {
				if(res.status == "OK"){
				  
				}
			  })
			  this.getNoti();
			},
			error: err => {
			  console.error('Fetching FCM token failed: ', +err)
			}
		})		  
	}	
	
	receiveMessage(){
		this.fireMessaging.messages.subscribe(
			(payload) => {
				console.log("new message received. ", payload);
				// const notificationTitle = payload.notification.title;
				// const notificationOptions = {
				// body: payload.notification.body,
				// icon: payload.notification.image,
				// data: { click_action: payload.notification.data }
			//};
		})
	}
	
	
	getNoti(): void {
		this.fireMessaging.messages.subscribe((message: any) => {
			console.log('Foreground message: ' + message.notification.title)
		})	
		// this.fireMessaging.onBackgroundMessage(payload =>{
		// 	console.log(payload);
		// 	const notificationTitle = payload.notification.title;
		// 	const notificationOptions = {
		// 		body: payload.notification.body,
		// 		icon: payload.notification.image,
		// 		data: { click_action: payload.notification }
		// 	};
		// 	// navigator.serviceWorker.ready.then(function(reg) {
		// 	// 	//reg.showNotification(notificationTitle, notificationOptions);
		// 	// })
		// })
		
	}

  }